module.exports = __webpack_public_path__ + "static/media/stone4_0.75c805a5.gif";